const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

const uppercase = str => str.toUpperCase();

const lowercase = str => str.toLowerCase();

const alt = str => {
  if (str === undefined) return "0";
  return str;
};

const menuList = [{
    module: "MIG_DASHBOARD",
    type: "header",
    name: "ダッシュボード",
    url: "/MigDashboard",
    menuName: "MigDashboard",
    submenu: [],
    icon: "fas fa-fw fa-tachometer-alt"
  },
  {
    type: "menu",
    name: "提携先",
    url: "#",
    module: "PARTNER",
    submenu: [{
      type: "menu",
      module: "PARTNER_LIST",
      name: "一覧",
      url: "/partner_service_list",
      menuName: "partnersList"
    }],
    datatarget: "collapesPartners",
    icon: "fas fa-fw fa-id-card"
  },
  {
    type: "menu",
    name: "サービス",
    url: "#",
    module: "QUESTIONNAIRE",
    submenu: [{
      type: "menu",
      module: "QUESTIONNAIRE_LIST",
      name: "ヘルスチェック票通知設定",
      url: "/interviewsheet",
      menuName: "interviewsheet"
    }],
    datatarget: "collapesService",
    icon: "fas fa-fw fa-cog"
  },
  {
    type: "menu",
    name: "管理者",
    url: "#",
    module: "ADMIN",
    submenu: [{
      type: "menu",
      module: "ADMIN_LIST",
      name: "一覧",
      url: "/adminlist",
      menuName: "adminList"
    }],
    datatarget: "collapesAdmin",
    icon: "fas fa-fw fa-user"
  },
  {
    type: "menu",
    name: "マスタ",
    url: "#",
    module: "MASTER",
    submenu: [{
        type: "menu",
        module: "MASTER_PARTNER_CATEGORY",
        name: "提携先",
        url: "/partners",
        menuName: "partners"
      },
      {
        type: "menu",
        module: "MASTER_SERVICE",
        name: "サービス",
        url: "/service",
        menuName: "service"
      }
    ],
    datatarget: "collapesMaster",
    icon: "fas fa-fw fa-lock"
  },
  {
    type: "menu",
    name: "通知",
    url: "#",
    module: "NOTIFICATION_MENU",
    submenu: [{
      type: "menu",
      name: "一覧",
      url: "/notification",
      module: "NOTIFICATION",
      menuName: "notication"
    }],
    datatarget: "collapesNotification",
    icon: "fas fa-bell"
  },
  {
    module: "PARTNER_DASHBOARD",
    type: "header",
    name: "ダッシュボード",
    url: "/dashboard",
    menuName: "Dashboard",
    submenu: [],
    icon: "fas fa-fw fa-tachometer-alt"
  },
  {
    type: "menu",
    name: "ユーザ",
    url: "/user",
    menuName: "user",
    module: "PARTNER_USER",
    icon: "fas fa-fw fa-lock",
    submenu: []
  },
  {
    type: "menu",
    name: "管理者",
    url: "/userList",
    menuName: "userlist",
    module: "PARTNER_ADMIN",
    icon: "fas fa-fw fa-user",
    submenu: []
  },
  {
    type: "menu",
    name: "通知",
    url: "/partnernotification",
    module: "NOTIFICATION_PARTNER",
    submenu: [],
    icon: "fas fa-bell"
  },
  {
    type: "menu",
    name: "支店",
    url: "/storemanagement",
    module: "BRANCH",
    submenu: [],
    datatarget: "collapesBranches",
    icon: "fas fa-store"
  },
  {
    type: "menu",
    name: "会社情報",
    module: "PARTNER_ABOUT",
    url: "/companyinfo",
    menuName: "companyinfo",
    submenu: [],
    icon: "fas fa-fw fa-cog"
  },
]
export const filters = {
  capitalize,
  uppercase,
  lowercase,
  alt,
  menuList
};